module.exports = __webpack_public_path__ + "img/what_get.2a5b88ea.jpg";